import React from 'react';
import '../../css/contacts/ContactCard.css';

/**
 * Карточка контакта
 */
export default function ContactCard({ contact, className = "" }) {
    if (!contact) return null;

    const { name, role, email, description } = contact;

    return (
        <div className={`contact-card ${className}`}>
            <div className="contact-card__header">
                <h4 className="contact-card__name">{name}</h4>
                <span className="contact-card__role">{role}</span>
            </div>
            
            {description && (
                <p className="contact-card__description">{description}</p>
            )}
            
            {email && (
                <a href={`mailto:${email}`} className="contact-card__email">
                    {email}
                </a>
            )}
        </div>
    );
}
